import moment from "moment";
import SmallProfileCard from "../../components/ContactInfo/SmallProfileCard";
import MasterComponent from "../../components/Forms";
import { constants } from "../../constants/common";
import { MasterConfigs } from "../../interfaces/entity";
import { Image, Modal, Typography } from "antd";
import { useState } from "react";
import PdfView from "../../components/custom/PDFView";
const { Text } = Typography;

const Attachments = ({ refType, refId }) => {
    const [selectedURL, setSelectedURL] = useState(null);

    const config: MasterConfigs = {
        api: () => `/attachments`,
        queryParams: {
            refType,
            refId
        },
        title: "Attachments",
        modalTitle: (e) => `${e} Attachment`,
        apiParams: {
            refType,
            refId
        },
        isActionTab: true,
        getColumns: () => [
            {
                title: "File Name", dataIndex: "fileName", key: "fileName",
                render: (text, record) => {
                    let fileName = text.split("/").pop();
                    fileName = fileName ? fileName.split('-').pop() : "No File";
                    let fileType = fileName.split(".").pop().toLowerCase();
                    if (["jpg", "jpeg", "png"].includes(fileType)) {
                        fileName = `${fileName}`;
                        return <div className="flex items-center gap-2">
                            <div className="w-10 h-10">
                                <Image src={`${process.env.FILE_URL}${text}`} alt={fileName} />
                            </div>
                            <div>
                                {fileName}
                            </div>
                        </div>;
                    } else if (["doc", "docx", 'pdf'].includes(fileType)) {
                        fileName = `${fileName}`;
                        return (
                            <Text onClick={() => setSelectedURL(`${process.env.FILE_URL}${text}`)} className="cursor-pointer text-blue-500 hover:underline">
                                {fileName}
                            </Text>
                        );
                    }
                }
            },
            {
                title: "Created By", dataIndex: "createdBy", key: "createdBy",
                render: (text) => text ? <SmallProfileCard
                    name={constants.GET_FULL_NAME(text)}
                    avatar={text.avatar}
                /> : 'Self'
            },
            {
                title: "Created At", dataIndex: "createdAt", key: "createdAt",
                render: (text) => text ? moment(text).format("LLL") : null
            }
        ],
        getFormColumns: () => [
            {
                label: "File",
                name: "fileName",
                type: "file",
                uploadProps: {
                    accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
                    maxCount: 1,
                    beforeUpload: (file) => {
                        const isValidType = /\.(pdf|doc|docx|jpg|jpeg|png)$/i.test(file.name);
                        if (!isValidType) {
                            alert("You can only upload PDF, DOC, DOCX, JPG, JPEG, or PNG files!");
                        }
                        return isValidType;
                    }
                },
                rules: [{ required: true, message: "File is required" }],
            },
        ],
        actions: [
            {
                actionType: "Add",
                name: "Add Attachment",
            }
        ]
    }

    return (
        <>
            <Modal
                open={selectedURL}
                title={'View Attachment'}
                onCancel={() => setSelectedURL(null)}
                width={1200}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <PdfView url={selectedURL} />
            </Modal>
            <MasterComponent config={config} isModal={true} />
        </>
    );
}


export default Attachments;